/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Portals_SklikInputs */

const cs_property_portals_sklik = /** @type {(inputs: Property_Portals_SklikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik produktové inzeráty`)
};

const en_property_portals_sklik = /** @type {(inputs: Property_Portals_SklikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik product ads`)
};

/**
* | output |
* | --- |
* | "Sklik product ads" |
*
* @param {Property_Portals_SklikInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_portals_sklik = /** @type {((inputs?: Property_Portals_SklikInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Portals_SklikInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_portals_sklik(inputs)
	return cs_property_portals_sklik(inputs)
});